// extracted by mini-css-extract-plugin
export var box = "_1m-1";
export var checked = "_1m-2";
export var descriptionSpacer = "_1m-9";
export var disabled = "_1m-3";
export var icon = "_1m-6";
export var input = "_1m-0";
export var labelSpacer = "_1m-8";
export var medium = "_1m-5";
export var small = "_1m-4";
export var text = "_1m-7";